import { render, staticRenderFns } from "./ProjectFilter.vue?vue&type=template&id=5cd338ec&scoped=true&"
import script from "./ProjectFilter.vue?vue&type=script&lang=js&"
export * from "./ProjectFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd338ec",
  null
  
)

export default component.exports